import {Inject, Injectable, NgZone, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MCardEventsService {

  private subscriptions: {
    [key: string]: Array<(...args: Array<any>) => void>;
  } = {};

  constructor(private zone: NgZone, @Inject(PLATFORM_ID) private platformId: any) {
  }

  public init(events: string[]): void {
    events.forEach((eventName) => {
      this.subscriptions[eventName] = [];
    });

    if (isPlatformBrowser(this.platformId)) {
      (window as any)['mCardEvent'] = (eventName: any, args: any) => {
        if (!this.subscriptions[eventName]) {
          throw new Error('Event has to be defined in the event list.');
        }

        this.zone.run(() => {
          this.fireEvent(eventName, args);
        });
      };
    }

    (window as any)['subscribeToAngularEvent'] = (eventName: any, fn: any) => {
      this.subscribe(eventName, fn);
    };

    (window as any)['unsubscribeFromAngularEvent'] = (eventName: any) => {
      this.unsubscribe(eventName);
    };
  }

  public subscribe(eventName: string, fn: (...args: Array<any>) => void) {
    if (this.subscriptions[eventName]) {
      this.subscriptions[eventName].push(fn);
    } else {
      this.subscriptions[eventName] = [fn];
    }

    return this;
  }

  public unsubscribe(eventName: string) {
    if (this.subscriptions[eventName]) {
      this.subscriptions[eventName] = [];
    }

    return this;
  }

  public fireEvent(eventName: string, args: Array<any>) {
    if (this.subscriptions[eventName]) {
      this.subscriptions[eventName].forEach((fn) => {
        fn(args);
      });
    }

    return this;
  }
}
